module.exports = __webpack_public_path__ + "img/1800f.bfbe8abe.png";